import React, { useEffect } from 'react';

import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import FloatingButton from '@mui/material/Fab';
import { saveCastingSessionId } from '@redux/casting';
import { usePlayerStateSelector } from "@redux/player";
import QRCodeGenerator from 'qrcode.react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAsyncFn, useToggle } from 'react-use';

import { ReactComponent as CastingIcon } from 'assets/casting-icon.svg';
import Modal from 'components/b2c/Modal';
import Loader from 'components/shared/Loader';
import { PATHS } from 'constants/pathsB2c';
import { useCastingListener } from 'services/hooks/useCastingListener';
import { getCasting, postCastingEvent } from 'services/networking/casting';
import { CASTING_SESSION_ID_QUERY_STRING } from 'shared-types/casting';
import { PlayerEvent } from 'shared-types/player-event';

import { FloatingButtonContainer } from './CastingButtonAndModal.style';

const CastingModal: React.FunctionComponent<{ isUserConnected: boolean }> = ({
  isUserConnected,
}) => {
  const [isOpen, setIsOpen] = useToggle(false);
  const [casting, fetchCasting] = useAsyncFn(getCasting, [], { loading: true });
  const [, sendCastingEvent] = useAsyncFn(postCastingEvent);
  const playerState = usePlayerStateSelector()

  const castingConnectionUrl = `${window.location.origin}${
    isUserConnected ? PATHS.AUTHENTICATED_CASTING : ''
  }?${CASTING_SESSION_ID_QUERY_STRING}=${casting.value?.castingSessionId}`;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      fetchCasting();
    }
  }, [isOpen, fetchCasting]);

  useCastingListener(
    {
      [PlayerEvent.CONNECTION]: () => {
        const castingSessionId = casting.value?.castingSessionId;
        if (castingSessionId) {
          dispatch(saveCastingSessionId(castingSessionId));
          sendCastingEvent(
            castingSessionId,
            PlayerEvent.INIT_CASTING_SESSION,
            JSON.stringify(playerState),
          );
          navigate(PATHS.PLAYER);
        }
      },
    },
    casting.value?.castingSessionId,
  );

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        icon={<PhoneIphoneIcon color='secondary' fontSize='inherit' />}
        titleId='layout.casting-modal.title'
        descriptionId='layout.casting-modal.description'
      >
        {casting.loading ? (
          <Loader />
        ) : casting.error ? (
          <div>Error: {casting.error.message}</div>
        ) : (
          <QRCodeGenerator includeMargin={true} size={240} value={castingConnectionUrl} />
        )}
      </Modal>
      <FloatingButtonContainer>
        <FloatingButton onClick={() => setIsOpen(true)}>
          <CastingIcon />
          <FormattedMessage id='layout.casting-modal.button-label' />
        </FloatingButton>
      </FloatingButtonContainer>
    </>
  );
};

export default CastingModal;
